import { gql } from "@apollo/client";

export const POST_APPOINTMENT = gql`
  mutation postAppointment($input: BookAppointmentInput!) {
    postAppointment(input: $input) {
      userID,appointmentID
    }
  }
`;
